// This file is automatically generated. DO NOT EDIT, all your changes would be lost.
import React from 'react';
var CloseIcon = /*#__PURE__*/React.memo(({
  className,
  style
}) => /*#__PURE__*/React.createElement("svg", {
  width: 30,
  height: 30,
  viewBox: "0 0 30 30",
  xmlns: "http://www.w3.org/2000/svg",
  style: style,
  className: className
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.113 7.931a1 1 0 010 1.414l-5.657 5.657 5.657 5.657a1 1 0 11-1.414 1.414l-5.657-5.657-5.657 5.657a1 1 0 11-1.414-1.414l5.657-5.657L7.97 9.345a1 1 0 111.414-1.414l5.657 5.657L20.7 7.93a1 1 0 011.414 0z",
  fill: "#BBB",
  fillRule: "evenodd"
})));
export default CloseIcon;